/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} League_Open_Princes_LabelInputs */



/**
* | output |
* | --- |
* | "Open to country Princes" |
*
* @param {League_Open_Princes_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const league_open_princes_label = /** @type {((inputs?: League_Open_Princes_LabelInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<League_Open_Princes_LabelInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ouverte aux Princes du pays")
	if (locale === "es") return /** @type {LocalizedString} */ ("Abierta a los Princes del país")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Aberta aos Princes do país")
	if (locale === "it") return /** @type {LocalizedString} */ ("Aperto ai Prince del paese")
	return /** @type {LocalizedString} */ ("Open to country Princes")
});